/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';
import PageHeader from 'antd/lib/page-header';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';

import './SideControl.less';

import buildingLogoLight from '../../icons/building-icon-light.svg';
import buildingLogoDark from '../../icons/building-icon-dark.svg';
import buildingLogoSelectedLight from '../../icons/building-icon-selected-light.svg';
import buildingLogoSelectedDark from '../../icons/building-icon-selected-dark.svg';

import addGrey from '../../icons/add-grey.svg';
import addWhite from '../../icons/add-white.svg';
import addDark from '../../icons/add-dark.svg';
import addLightGrey from '../../icons/add-light-grey.svg';
import searchIcon from '../../icons/search.svg';
import searchDarkIcon from '../../icons/search-dark.svg';

import addBuildingsLogo from '../../images/adding-buildings.png';

import { HamburgerIcon } from '../PageWrapper/components/HamburgerIcon';
import monitoringLightIcon from '../PageWrapper/assets/monitoring-light.svg';
import monitoringDarkIcon from '../PageWrapper/assets/monitoring-dark.svg';
import monitoringBlueIcon from '../PageWrapper/assets/monitoring-blue.svg';
import alertsLightIcon from '../PageWrapper/assets/alerts-light.svg';
import alertsDarkIcon from '../PageWrapper/assets/alerts-dark.svg';
import alertsBlueIcon from '../PageWrapper/assets/alerts-blue.svg';
import helpLightIcon from '../PageWrapper/assets/help-light.svg';
import helpDarkIcon from '../PageWrapper/assets/help-dark.svg';
import helpBlueIcon from '../PageWrapper/assets/help-blue.svg';

import { ReactComponent as BackIcon } from './back_button.svg';

export const SideControl = (props) => {
  const { Sider } = Layout;
  const { theme, buildings, selectedBuildingId, selectBuilding, setIsAddBuildingModalOpen, loadingBuildings } = props;
  const { Search } = Input;
  const { pathname } = useLocation();
  const history = useHistory();

  let timeout = 0;

  const [searchQuery, setSearchQuery] = useState('');

  const [selectedCategory, setSelectedCategory] = useState('');
  const [permissions, setPermissions] = useState([]);

  const themedSearch = theme === 'dark' ? searchDarkIcon : searchIcon;

  const filterBuilding = (buildingSearch) => {
    return buildingSearch.name.toLowerCase().includes(searchQuery);
  };

  const getBuildingIcon = (identifier) => {
    if (selectedBuildingId === identifier) {
      return theme === 'light' ? (
        <img src={buildingLogoSelectedLight} alt="selected building logo" />
      ) : (
        <img src={buildingLogoSelectedDark} alt="selected building logo" />
      );
    }
    return theme === 'light' ? (
      <img src={buildingLogoLight} alt="building logo" />
    ) : (
      <img src={buildingLogoDark} alt="building logo" />
    );
  };

  const isCategoryPath = (category) => {
    const categories = ['home', 'savings', 'monitoring', 'alerts', 'help'];
    return categories.find((c) => c === category);
  };

  useEffect(() => {
    const currentPath = pathname === '/' ? '/' : pathname.split('/')[1];

    if (currentPath) {
      setPermissions([]);
    }
    setSelectedCategory(currentPath);

    if (buildings.length > 0 && isCategoryPath(currentPath)) {
      let activeBuilding;

      if (!selectedBuildingId && currentPath !== 'help') {
        activeBuilding = buildings.find((b) => b.identifier === pathname.split('/')[2]);
        selectBuilding(activeBuilding);

        setPermissions(activeBuilding.permissions);
      } else if (selectedBuildingId && currentPath !== 'help') {
        activeBuilding = buildings.find((b) => b.identifier === selectedBuildingId);
        setPermissions(activeBuilding.permissions);
      } else if (selectedBuildingId && currentPath === 'help') {
        activeBuilding = buildings.find((b) => b.identifier === selectedBuildingId);
        setPermissions(activeBuilding.permissions);
      }
    }
  }, [pathname, buildings]);
  
  function getViewportState(
    width = (typeof window !== 'undefined'
      ? (window.visualViewport?.width || window.innerWidth || 0)
      : 0),
    height = (typeof window !== 'undefined'
      ? (window.visualViewport?.height || window.innerHeight || 0)
      : 0)
  ) {
    const hasWindow = typeof window !== 'undefined';
    const { navigator: nav } = hasWindow ? window : { navigator: undefined };

    // Rotation-robust metrics
    const shortest = Math.min(width, height || width);
    const longest  = Math.max(width, height || width);

    // Device/interaction signals (guarded for SSR)
    const coarsePointer = hasWindow && window.matchMedia
      ? window.matchMedia('(pointer: coarse)').matches
      : false;

    const hasTouch = !!(nav?.maxTouchPoints || nav?.msMaxTouchPoints);

    const uaMobile = (nav?.userAgentData?.mobile ??
                      /Android|iPhone|iPad|iPod|Mobile|IEMobile|BlackBerry/i.test(nav?.userAgent || ''));

    // Heuristic: treat as handheld only if it's touch/coarse AND not a huge screen
    const likelyHandheld = (uaMobile || hasTouch || coarsePointer) && longest <= 1024;

    // Final mobile flag:
    //  - Your breakpoint (shortest side < 600), robust to rotation, OR
    //  - Handheld heuristic (so phone-in-landscape doesn't look like desktop)
    const isMobile = shortest < 600 || likelyHandheld;

    return isMobile;
  }


  const handleSelectBuilding = (building) => {

    const isMobile = getViewportState();
    if (isMobile) {
      history.push(`/monitoring/${building.identifier}`);
      setSearchQuery('');
    } else {
      selectBuilding(building);
      setSearchQuery('');
    }
    
  }

  return (
    <>
      {selectedCategory !== '/' ? (
        <>
          <Sider
            width={150}
            collapsed={false}
            className="app-menu"
            trigger={<HamburgerIcon theme={theme} />}
            theme={theme}
          >
            <div className="back-section">
              <button
                className={`back-button back-button-${theme}`}
                onClick={() => {
                  history.push(`/`);
                  selectBuilding({});
                }}
              >
                <BackIcon color="#46b3ba" width={20} />
                <span>Back</span>
              </button>
            </div>
            <Menu className="app-sidebar-top-menu" mode="inline" theme={theme} selectedKeys={[selectedCategory]}>
              {permissions.indexOf('monitoring') !== -1 && (
                <Menu.Item
                  key="monitoring"
                  title={null}
                  onClick={() => {
                    sessionStorage.setItem('customDataPoints', JSON.stringify([]));
                    history.push(`/monitoring/${selectedBuildingId}/`);
                  }}
                >
                  {selectedCategory === 'monitoring' ? (
                    <img src={monitoringBlueIcon} alt="selected monitoring icon" className="app-sidebar__icon" />
                  ) : (
                    <img
                      src={theme === 'light' ? monitoringLightIcon : monitoringDarkIcon}
                      alt="monitoring icon"
                      className="app-sidebar__icon"
                    />
                  )}
                  <span className="app-menu-item-name">Monitoring</span>
                </Menu.Item>
              )}
              {permissions.indexOf('alerts') !== -1 && (
                <Menu.Item
                  key="alerts"
                  title={null}
                  onClick={() => {
                    history.push(`/alerts/${selectedBuildingId}/`);
                  }}
                >
                  {selectedCategory === 'alerts' ? (
                    <img src={alertsBlueIcon} alt="selected alerts icon" className="app-sidebar__icon" />
                  ) : (
                    <img
                      src={theme === 'light' ? alertsLightIcon : alertsDarkIcon}
                      alt="alerts icon"
                      className="app-sidebar__icon"
                    />
                  )}
                  <span className="app-menu-item-name">Alerts</span>
                </Menu.Item>
              )}
            </Menu>
            <Menu className="app-sidebar-bottom-menu" mode="inline" theme={theme} selectedKeys={[selectedCategory]}>
              <Menu.Item key="help" title={null} onClick={() => history.push('/help/')}>
                {selectedCategory === 'help' ? (
                  <img src={helpBlueIcon} alt="selected help icon" />
                ) : (
                  <img src={theme === 'light' ? helpLightIcon : helpDarkIcon} alt="help icon" />
                )}
                <span className="app-menu-item-name">Help</span>
              </Menu.Item>
            </Menu>
          </Sider>
          {
            pathname.split('/')[1] === 'help' || pathname.split('/')[1] === 'settings' ? 
            null :
            <div className="sb-mobile-side">
              {permissions.indexOf('monitoring') !== -1 && (
                <div
                  key="monitoring"
                  title={null}
                  onClick={() => {
                    sessionStorage.setItem('customDataPoints', JSON.stringify([]));
                    history.push(`/monitoring/${selectedBuildingId}/`);
                  }}
                  className="app-sidebar__wrapper"
                >
                  {selectedCategory === 'monitoring' ? (
                    <img src={monitoringBlueIcon} alt="selected monitoring icon" className="app-sidebar__icon" />
                  ) : (
                    <img
                      src={theme === 'light' ? monitoringLightIcon : monitoringDarkIcon}
                      alt="monitoring icon"
                      className="app-sidebar__icon"
                    />
                  )}
                  <span className="app-menu-item-name">Monitoring</span>
                </div>
                )}
              {permissions.indexOf('alerts') !== -1 && (
                <div
                  key="alerts"
                  title={null}
                  onClick={() => {
                    history.push(`/alerts/${selectedBuildingId}/`);
                  }}
                  className="app-sidebar__wrapper"
                >
                  {selectedCategory === 'alerts' ? (
                    <img src={alertsBlueIcon} alt="selected alerts icon" className="app-sidebar__icon" />
                  ) : (
                    <img
                      src={theme === 'light' ? alertsLightIcon : alertsDarkIcon}
                      alt="alerts icon"
                      className="app-sidebar__icon"
                    />
                  )}
                  <span className="app-menu-item-name">Alerts</span>
                </div>
              )}
            </div>
          }
        </>
      ) : (
        <Sider width={300} className="main-sider" theme={theme} collapsed={false}>
          {loadingBuildings ? (
            <div style={{ height: '100%', display: 'grid', placeContent: 'center' }}>
              <Spin />
            </div>
          ) : (
            <div className="side-control-layout">
              <PageHeader title={`My Buildings (${buildings.length})`} />
              {buildings.length > 0 ? (
                <>
                  <div className="main-sider__search">
                    <Search
                      id="search"
                      placeholder="Search buildings"
                      allowClear
                      prefix={<img src={themedSearch} alt="search icon" />}
                      style={{ width: '80%' }}
                      enterButton={true}
                      bordered={false}
                      onChange={(e) => {
                        e.persist();
                        if (timeout) clearTimeout(timeout);
                        timeout = setTimeout(() => {
                          setSearchQuery(e.target.value.toLowerCase());
                        }, 500);
                      }}
                      onSearch={(value) => {
                        setSearchQuery(value);
                      }}
                    />
                  </div>
                  <div className="main-sider__add-building-container">
                    <div
                      className="main-sider__add-building"
                      onClick={() => setIsAddBuildingModalOpen(true)}
                      onKeyDown={() => setIsAddBuildingModalOpen(true)}
                      role="button"
                      tabIndex="0"
                    >
                      {theme === 'light' ? (
                        <img src={addGrey} alt="add button logo" style={{ marginRight: '1rem' }} />
                      ) : (
                        <img src={addLightGrey} alt="add button logo" style={{ marginRight: '1rem' }} />
                      )}
                      <span>Add Buildings</span>
                    </div>
                  </div>
                  <Menu
                    mode="inline"
                    theme={theme}
                    selectedKeys={[selectedBuildingId]}
                    style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto' }}
                  >
                    {buildings
                      .sort((a, b) => b.alert_count - a.alert_count)
                      .filter((b) => filterBuilding(b))
                      .map((b) => {
                        const { alert_count, identifier, name } = b;
                        return (
                          <Menu.Item
                            key={identifier}
                            onClick={() => handleSelectBuilding(b)}
                          >
                            <div className="side-control__item">
                              {getBuildingIcon(identifier)}
                              <div className="item__name" title={name}>
                                {name}
                              </div>
                              {alert_count ? (
                                <div className="main-sider__building-alerts-count">{alert_count}</div>
                              ) : null}
                            </div>
                          </Menu.Item>
                        );
                      })}
                  </Menu>
                </>
              ) : (
                <div className="no-buildings">
                  <img src={addBuildingsLogo} alt="add buildings" className="add-buildings-logo" />
                  <Button
                    block
                    htmlType="submit"
                    size="large"
                    className="add-buildings__button"
                    onClick={() => setIsAddBuildingModalOpen(true)}
                  >
                    <div className="add-buildings__button-text">
                      {theme === 'light' ? (
                        <img className="add-building-icon" src={addWhite} alt="add button logo" />
                      ) : (
                        <img className="add-building-icon" src={addDark} alt="add button logo" />
                      )}
                      Add Buildings
                    </div>
                  </Button>
                  <div className="no-buildings-text">Your buildings will be shown here once we&apos;ve added them</div>
                </div>
              )}
            </div>
          )}
        </Sider>
      )}
    </>
  );
};
